module.exports = __webpack_public_path__ + "assets/img/img-premium-benefit-file.c99b098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/premium/img-premium-benefit-file.jpg
// module id = 981
// module chunks = 1